import React from 'react';
import { useRouterContext } from './RouterContext';
import { GuardResourceContext } from '../guard';
export var useRouter = function (_a) {
    var match = _a.match;
    var actions = useRouterContext();
    var render = actions.match(match);
    if (!render) {
        return { content: null };
    }
    var resourceName = actions.getResourceName();
    var content = render({
        params: actions.getParams(),
        query: actions.getQuery(),
        name: actions.getName()
    });
    return {
        content: resourceName
            ? React.createElement(GuardResourceContext.Provider, { value: { resourceName: resourceName } }, content)
            : content
    };
};
export var useRouterActions = function () {
    return useRouterContext();
};
//# sourceMappingURL=hooks.js.map